import { DatePicker } from "antd";
import { Form, Formik } from "formik";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import { swalError, swalSuccess } from "../../../../helpers/swal";
import * as Action from "../../../applicant/_redux/applicantActions";
import * as EmployeeListAction from "../../../employee/_redux/employeeActions";
import * as JobDescriptionAction from "../../../job-description/_redux/jobDescriptionActions";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import flags from "react-phone-number-input/flags";

const _init = {
  job_id: "",
  first_name: "",
  middle_name: "",
  last_name: "",
  date_of_birth: "",
  gender: "",
  marital_status: "",
  spouse_name: "",
  father_name: "",
  mother_name: "",
  religion: "",
  country_of_birth: "",
  nationality_id: "",
  nationality_type: "",
  nid: "",
  passport_number: "",
  passport_expire_date: "",
  tin: "",
  contact_number: "",
  alternative_contact_number: "",
  email: "",
  blood_group: "",
  is_disable: "",
  about_disability: "",
  emergency_contact_number: "",
  relationsip_with_emergency_contact: "",
  height: "",
  weight: "",
  expected_salary: "",
  referral: "",
  other_religion_name: "",
  work_permit_issue_date: "",
  work_permit_expiry_date: "",
  visa_expiry_date: "",
  second_nationality_id: "",
  second_nationality_type: "",
  is_ex_employee: "",
  ex_employee_code: "",
  prev_joining_date: "",
  prev_last_working_date: "",
  ex_superviosor_name: "",
  ex_superviosor_designation: "",
  ex_superviosor_email: "",
  ex_superviosor_phone: "",
  alternative_email: "",
  passport_issue_date: "",
  passport_expiry_date: "",
};

const marital_status = [
  {
    value: "Single",
    label: "Single",
  },
  {
    value: "Married",
    label: "Married",
  },
  {
    value: "Divorced",
    label: "Divorced",
  },
  {
    value: "Widowed",
    label: "Widowed",
  },
];

const options = [
  {
    value: "Male",
    label: "Male",
  },
  {
    value: "Female",
    label: "Female",
  },
  {
    value: "Other",
    label: "Other",
  },
];

const religions = [
  {
    value: "Islam",
    label: "Islam",
  },
  {
    value: "Hinduism",
    label: "Hinduism",
  },
  {
    value: "Buddhism",
    label: "Buddhism",
  },
  {
    value: "Christianity",
    label: "Christianity",
  },
  {
    value: "Other",
    label: "Other",
  },
];

const bloodGroupOptions = [
  {
    value: "A+",
    label: "A+",
  },
  {
    value: "B+",
    label: "B+",
  },
  {
    value: "O+",
    label: "O+",
  },
  {
    value: "O-",
    label: "O-",
  },
  {
    value: "AB+",
    label: "AB+",
  },
  {
    value: "AB-",
    label: "AB-",
  },
];

const disabilityOptions = [
  {
    value: "1",
    label: "Yes",
  },
  {
    value: "0",
    label: "No",
  },
];
const nationalityTypeOptions = [
  {
    value: "By Birth",
    label: "By Birth",
  },
];

export default function PersonalInformation({ id }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(_init);
  const {
    employeeProfile,
    nationalityList,
    countryList,
    jobList,
  } = useSelector(
    ({ employeeList, applicant, jobDescription, auth }) => ({
      employeeProfile: applicant.personal_info,
      nationalityList: applicant.nationalityList,
      countryList: applicant.countryList,
      jobList: jobDescription.jobListDropdown,
    }),
    shallowEqual
  );
  useEffect(() => {
    if (id) {
      dispatch(Action.getApplicantPersonalInfo(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(Action.getAllNationalityList());
    dispatch(Action.getAllCountry());
  }, [dispatch]);

  useEffect(() => {
    if (employeeProfile && Object.keys(employeeProfile).length > 0 && id) {
      const [feet, inch] = (employeeProfile?.height || "").split("'");

      setProfile({
        first_name: employeeProfile?.first_name,
        middle_name: employeeProfile?.middle_name,
        last_name: employeeProfile?.last_name,
        date_of_birth: employeeProfile?.date_of_birth,
        alternative_email: employeeProfile?.alternative_email,
        passport_issue_date: employeeProfile?.passport_issue_date,
        passport_expiry_date: employeeProfile?.passport_expiry_date,
        gender: employeeProfile?.gender,
        marital_status: employeeProfile?.marital_status,
        spouse_name: employeeProfile?.spouse_name,
        father_name: employeeProfile?.father_name,
        mother_name: employeeProfile?.mother_name,
        weight: employeeProfile?.weight,
        height: employeeProfile?.height,
        expected_salary: employeeProfile?.expected_salary,
        religion: employeeProfile?.religion,
        other_religion_name: employeeProfile?.other_religion_name,
        country_of_birth: employeeProfile?.country_of_birth,
        nationality_id: employeeProfile?.nationality_id,
        second_nationality_type: employeeProfile?.second_nationality_type,
        second_nationality_id: employeeProfile?.second_nationality_id,
        nationality_type: employeeProfile?.nationality_type,
        work_permit_issue_date: employeeProfile?.work_permit_issue_date,
        work_permit_expiry_date: employeeProfile?.work_permit_expiry_date,
        visa_expiry_date: employeeProfile?.visa_expiry_date,
        is_ex_employee: employeeProfile?.is_ex_employee == 1 ? "Yes" : "No",
        nid: employeeProfile?.nid,
        nid_file_location: employeeProfile?.nid_file_location,
        passport_number: employeeProfile?.passport_number,
        passport_expire_date: employeeProfile?.passport_expire_date,
        tin: employeeProfile?.tin,
        contact_number: employeeProfile?.contact_number,
        alternative_contact_number: employeeProfile?.alternative_contact_number,
        email: employeeProfile?.email,
        blood_group: employeeProfile?.blood_group,
        is_disable: employeeProfile?.is_disable
          ? "" + employeeProfile?.is_disable
          : "0",
        about_disability: employeeProfile?.about_disability,
        emergency_contact_number: employeeProfile?.emergency_contact_number,
        relationsip_with_emergency_contact:
          employeeProfile?.relationsip_with_emergency_contact,
        referral: employeeProfile?.referral,
        height_ft: feet,
        height_in: inch?.substring(0, inch.length - 1),
      });
    } else {
      setProfile({ ..._init, job_id: Number(localStorage.getItem("JOB_ID")) });
    }
  }, [employeeProfile, id]);

  useEffect(() => {
    const payload = {
      department_id: null,
      jd_id: null,
      job_code: "",
      start_date: "",
      end_date: "",
      requisition_code: null,
      status: "",
    };
    dispatch(JobDescriptionAction.getJobListDropdown(payload));
  }, [dispatch]);

  // Validation schema
  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("First name is required"),
    // job_id: id ? Yup.number().required("Job is required") : Yup.number(),
    date_of_birth: Yup.string().required("Date of birth is required"),
    gender: Yup.string().required("Gender is required"),
    marital_status: Yup.string().required("Marital status is required"),
    father_name: Yup.string().required("Father's name is required"),
    mother_name: Yup.string().required("Mother's name is required"),
    religion: Yup.string().required("Religion is required"),
    country_of_birth: Yup.number().required("Country of birth is required"),
    // full_name_bn: Yup.string().required(
    //   "Employee Full Name (in Bangla) is required"
    // ),
    nationality_id: Yup.number().required("nationality is required"),
    nationality_type: Yup.string().required("nationality type is required"),
    is_disable: Yup.string().required("disability is required"),
    blood_group: Yup.string().required("blood group is required"),
    nid: Yup.string().when("nationality_id", {
      is: (val) => {
        const nationality = nationalityList?.find((item) => item.value == val);
        return nationality?.label.trim() === "Bangladeshi"; // Trim whitespace
      },
      then: Yup.string().required("NID is required"),
      otherwise: Yup.string().nullable(),
    }),
    passport_number: Yup.string().when("nationality_id", {
      is: (val) => {
        const nationality = nationalityList?.find((item) => item.value == val);
        return nationality?.label.trim() !== "Bangladeshi"; // Trim whitespace
      },
      then: Yup.string()
        .nullable()
        .required("passport is required"),
      otherwise: Yup.string().nullable(),
    }),
    email: Yup.string()
      .required("Email is required")
      .email("Invalid email format")
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        "Email must not contain special characters or spaces"
      ),
    contact_number: Yup.string().required("Contact number  is required"),
    // .matches(/^[0-9]{11}$/, "Contact number must be exactly 11 digits"),
    alternative_contact_number: Yup.string()
      // .matches(
      //   /^[0-9]{11}$/,
      //   "Alternative Contact number must be exactly 11 digits"
      // )
      .nullable()
      .notRequired(),
    expected_salary: Yup.number()
      .nullable()
      .typeError("Expected salary must be number"),

    ex_employee_code: Yup.string().when("is_ex_employee", {
      is: (val) => val == "Yes",
      then: Yup.string().required("pin is required"),
      otherwise: Yup.string().nullable(),
    }),

    prev_joining_date: Yup.string().when("is_ex_employee", {
      is: (val) => val == "Yes",
      then: Yup.string().required("previous joining date is required"),
      otherwise: Yup.string().nullable(),
    }),

    prev_last_working_date: Yup.string().when("is_ex_employee", {
      is: (val) => val == "Yes",
      then: Yup.string().required("previous last working date is required"),
      otherwise: Yup.string().nullable(),
    }),
  });
  const handleSaveProfile = async (values) => {
    const formData = new FormData();
    console.log(values);
    values.height = values.height_ft
      ? `${values.height_ft}'${values.height_in || 0}"`
      : null;
    values.is_ex_employee = values.is_ex_employee == "Yes" ? 1 : 0;
    if (values && Object.keys(values).length > 0) {
      for (let key in values) {
        if (values.hasOwnProperty(key)) {
          let value = values[key];

          if (typeof value === "object" && value != null && value != "") {
            if (value instanceof File) {
              formData.append(key, value);
            } else if (Array.isArray(value)) {
              formData.append(key, JSON.stringify(value));
            } else {
              formData.append(key, JSON.stringify(value));
            }
          } else if (typeof value !== "undefined") {
            if (typeof value == "boolean") {
              formData.append(key, value == false ? 0 : 1);
            } else {
              formData.append(key, value);
            }
          }
        }
      }

      if (id) {
        await API.patch(`/hrms_applicant/${id}`, formData)
          .then((res) => {
            if (res.data.success) {
              swalSuccess("Personal information updated successfully");
              // console.log(res);
              // if (typeof window !== "undefined") {
              //   window.location.href = `/applicant/user?step=1&applicantId=${id}`;
              // }
              if (id) {
                dispatch(
                  Action.createProfileScore(
                    {
                      name: ["Personal Information"],
                      applicant_id: id,
                    },
                    async () => {
                      await dispatch(Action.getApplicantPersonalInfo(id));
                    }
                  )
                );
              }
            } else {
              if (res.data.message) {
                swalError(res.data.message);
              } else {
                swalError("something went wrong");
              }
            }
          })
          .catch((error) => {
            console.log(error);
            swalError("something went wrong");
          });
      } else {
        formData.append("insert_type", "external");
        await API.post(`/hrms_applicant`, formData)
          .then((res) => {
            if (res.data.success) {
              swalSuccess("Candidate Profile Created");
              console.log(res.data);
              // dispatch(Action.createProfileScore({
              //   company_id
              // }))
              dispatch(
                Action.createProfileScore(
                  {
                    name: ["Personal Information"],
                    applicant_id: res.data?.data[0]?.lastId?.id,
                  },
                  () => {
                    if (typeof window !== "undefined") {
                      window.location.href = `/public-applicant/basic-info/${res.data?.data[0]?.lastId?.id}`;
                    }
                  }
                )
              );
            } else {
              if (res.data.message) {
                swalError(res.data.message);
              } else {
                swalError("something went wrong");
              }
            }
          })
          .catch((error) => {
            console.log(error);
            swalError("something went wrong");
          });
      }
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <>
      <div className="card card_body_box mb-5">
        <Formik
          initialValues={profile}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSaveProfile(values);
          }}
        >
          {({ handleSubmit, setFieldValue, values, errors, touched }) => (
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12">
                  <div className="card_header_with_edit_btn">
                    <div className="title">
                      <h2>Personal Information</h2>
                    </div>
                  </div>

                  <hr />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        {!id && (
                          <>
                            <div className="col-md-6 mb-3">
                              <SelectInput
                                name="job_id"
                                style={{
                                  width: "100%",
                                  height: "44px",
                                }}
                                isRequired
                                label={`Job Title`}
                                size="small"
                                onChange={(val) => {
                                  setFieldValue("job_id", val);
                                }}
                                value={values.job_id}
                                options={jobList}
                              />
                              {errors.job_id && touched.job_id && (
                                <div className="text-danger">
                                  {errors.job_id}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-4">
                              <Input
                                label={"Expected Salary (BDT Per Month)"}
                                name="expected_salary"
                                isRequired
                                value={values.expected_salary}
                                onChange={(e) => {
                                  setFieldValue(
                                    "expected_salary",
                                    e.target.value
                                  );
                                }}
                              />
                              {errors.expected_salary &&
                                touched.expected_salary && (
                                  <div className="text-danger">
                                    {errors.expected_salary}
                                  </div>
                                )}
                            </div>
                          </>
                        )}

                        <div className="col-md-6 mb-4">
                          <Input
                            label={"First Name"}
                            isRequired
                            name="first_name"
                            value={values.first_name}
                            onChange={(e) => {
                              setFieldValue("first_name", e.target.value);
                            }}
                          />
                          {errors.first_name && touched.first_name && (
                            <div className="text-danger">
                              {errors.first_name}
                            </div>
                          )}
                        </div>

                        <div className="col-md-6 mb-4">
                          <Input
                            label={"Middle Name"}
                            name="middle_name"
                            value={values.middle_name}
                            onChange={(e) => {
                              setFieldValue("middle_name", e.target.value);
                            }}
                          />
                        </div>

                        <div className="col-md-6 mb-4">
                          <Input
                            label={"Last Name"}
                            name="last_name"
                            value={values.last_name}
                            onChange={(e) => {
                              setFieldValue("last_name", e.target.value);
                            }}
                          />
                          {errors.last_name && touched.last_name && (
                            <div className="text-danger">
                              {errors.last_name}
                            </div>
                          )}
                        </div>

                        <div className="col-md-6 mb-4">
                          <label className="required">Date of Birth</label>
                          <DatePicker
                            style={{ width: "100%", height: "44px" }}
                            format="YYYY-MM-DD"
                            disabledDate={(current) => {
                              const customDate = moment().format("YYYY-MM-DD");
                              return (
                                current &&
                                current >= moment(customDate, "YYYY-MM-DD")
                              );
                            }}
                            value={
                              values.date_of_birth
                                ? moment(values.date_of_birth)
                                : null
                            }
                            onChange={(date, dateString) => {
                              setFieldValue("date_of_birth", dateString);
                            }}
                          />
                          {errors.date_of_birth && touched.date_of_birth && (
                            <div className="text-danger">
                              {errors.date_of_birth}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <SelectInput
                            label={"Gender"}
                            isRequired
                            options={options}
                            value={values.gender}
                            onChange={(value) => {
                              setFieldValue("gender", value);
                            }}
                          />
                          {errors.gender && touched.gender && (
                            <div className="text-danger">{errors.gender}</div>
                          )}
                        </div>
                        <div className="col-md-6 mb-4">
                          {/* <Input
                          label={"Employee Height (Meter)"}
                          name="height"
                          value={values.height}
                          onChange={(e) => {
                            setFieldValue("height", e.target.value);
                          }}
                        /> */}
                          <label>Height</label>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group label-static">
                                <div class="input-group">
                                  <input
                                    name="height_stepper_ft"
                                    class="form-control"
                                    type="number"
                                    min="0"
                                    max="8"
                                    step="1"
                                    value={values.height_ft}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "height_ft",
                                        e.target?.value
                                      );
                                    }}
                                  />
                                  <span class="input-group-addon">ft</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group label-static">
                                <div class="input-group">
                                  <input
                                    name="height_stepper_in"
                                    class="form-control"
                                    type="number"
                                    min="0"
                                    max="11"
                                    step="1"
                                    value={values.height_in}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "height_in",
                                        e.target?.value
                                      );
                                    }}
                                  />
                                  <span class="input-group-addon">in</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {errors.height && touched.height && (
                            <div className="text-danger">{errors.height}</div>
                          )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <Input
                            label={"Weight(KG)"}
                            name="weight"
                            value={values.weight}
                            onChange={(e) => {
                              setFieldValue("weight", e.target.value);
                            }}
                          />
                          {errors.weight && touched.weight && (
                            <div className="text-danger">{errors.weight}</div>
                          )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <SelectInput
                            label={"Marital Status"}
                            isRequired
                            options={marital_status}
                            value={values.marital_status}
                            onChange={(value) => {
                              setFieldValue("marital_status", value);
                            }}
                          />
                          {errors.marital_status && touched.marital_status && (
                            <div className="text-danger">
                              {errors.marital_status}
                            </div>
                          )}
                        </div>
                        {values.marital_status == "Married" && (
                          <div className="col-md-6 mb-4">
                            <Input
                              label={"Spouse Name"}
                              value={values.spouse_name}
                              onChange={(e) => {
                                setFieldValue("spouse_name", e.target.value);
                              }}
                            />
                            {errors.spouse_name && touched.spouse_name && (
                              <div className="text-danger">
                                {errors.spouse_name}
                              </div>
                            )}
                          </div>
                        )}

                        <div className="col-md-6 mb-4">
                          <Input
                            label={"Father’s Name "}
                            isRequired
                            value={values.father_name}
                            onChange={(e) => {
                              setFieldValue("father_name", e.target.value);
                            }}
                          />
                          {errors.father_name && touched.father_name && (
                            <div className="text-danger">
                              {errors.father_name}
                            </div>
                          )}
                        </div>

                        <div className="col-md-6 mb-4">
                          <Input
                            label={"Mother’s Name"}
                            isRequired
                            value={values.mother_name}
                            onChange={(e) => {
                              setFieldValue("mother_name", e.target.value);
                            }}
                          />
                          {errors.mother_name && touched.mother_name && (
                            <div className="text-danger">
                              {errors.mother_name}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <SelectInput
                            label={"Religion"}
                            options={religions}
                            isRequired
                            value={values.religion}
                            onChange={(value) => {
                              setFieldValue("religion", value);
                            }}
                          />
                          {errors.religion && touched.religion && (
                            <div className="text-danger">{errors.religion}</div>
                          )}
                        </div>
                        {values.religion == "Other" && (
                          <div className="col-md-6 mb-4">
                            <Input
                              label={"Other Religion Name"}
                              isRequired
                              value={values.other_religion_name}
                              onChange={(e) => {
                                setFieldValue(
                                  "other_religion_name",
                                  e.target.value
                                );
                              }}
                            />
                            {errors.other_religion_name &&
                              touched.other_religion_name && (
                                <div className="text-danger">
                                  {errors.other_religion_name}
                                </div>
                              )}
                          </div>
                        )}
                        <div className="col-md-6 mb-4">
                          <SelectInput
                            label={"Country of Birth"}
                            isRequired
                            options={countryList}
                            value={values.country_of_birth}
                            onChange={(value) => {
                              setFieldValue("country_of_birth", value);
                            }}
                          />
                          {errors.country_of_birth &&
                            touched.country_of_birth && (
                              <div className="text-danger">
                                {errors.country_of_birth}
                              </div>
                            )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <SelectInput
                            label={"Nationality"}
                            isRequired
                            options={nationalityList}
                            value={values.nationality_id}
                            onChange={(value) => {
                              setFieldValue("nationality_id", value);
                            }}
                          />
                          {errors.nationality_id && touched.nationality_id && (
                            <div className="text-danger">
                              {errors.nationality_id}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <SelectInput
                            label={"Nationality Type"}
                            isRequired
                            options={nationalityTypeOptions}
                            value={values.nationality_type}
                            onChange={(value) => {
                              setFieldValue("nationality_type", value);
                            }}
                          />
                          {errors.nationality_type &&
                            touched.nationality_type && (
                              <div className="text-danger">
                                {errors.nationality_type}
                              </div>
                            )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <SelectInput
                            label={"2nd Nationality"}
                            options={nationalityList}
                            value={values.second_nationality_id}
                            onChange={(value) => {
                              setFieldValue("second_nationality_id", value);
                            }}
                          />
                          {errors.second_nationality_id &&
                            touched.second_nationality_id && (
                              <div className="text-danger">
                                {errors.second_nationality_id}
                              </div>
                            )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <SelectInput
                            label={"2nd Nationality Type"}
                            options={nationalityTypeOptions}
                            value={values.second_nationality_type}
                            onChange={(value) => {
                              setFieldValue("second_nationality_type", value);
                            }}
                          />
                          {errors.second_nationality_type &&
                            touched.second_nationality_type && (
                              <div className="text-danger">
                                {errors.second_nationality_type}
                              </div>
                            )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <Input
                            label={"NID Number"}
                            isRequired={
                              nationalityList
                                ?.find(
                                  (item) => item.value == values.nationality_id
                                )
                                ?.label?.trim() === "Bangladeshi"
                                ? true
                                : false
                            }
                            value={values.nid}
                            onChange={(e) => {
                              setFieldValue("nid", e.target.value);
                            }}
                          />
                          {errors.nid && touched.nid && (
                            <div className="text-danger">{errors.nid}</div>
                          )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <Input
                            label={"Passport Number"}
                            isRequired={
                              nationalityList
                                ?.find(
                                  (item) => item.value == values.nationality_id
                                )
                                ?.label?.trim() !== "Bangladeshi"
                                ? true
                                : false
                            }
                            value={values.passport_number}
                            onChange={(e) => {
                              setFieldValue("passport_number", e.target.value);
                            }}
                          />
                          {errors.passport_number &&
                            touched.passport_number && (
                              <div className="text-danger">
                                {errors.passport_number}
                              </div>
                            )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <label>Passport Expire Date</label>
                          <DatePicker
                            style={{ width: "100%", height: "44px" }}
                            format="YYYY-MM-DD"
                            // disabledDate={(current) => {
                            //   const customDate = moment().format("YYYY-MM-DD");
                            //   return (
                            //     current &&
                            //     current >= moment(customDate, "YYYY-MM-DD")
                            //   );
                            // }}
                            value={
                              values.passport_expire_date
                                ? moment(values.passport_expire_date)
                                : null
                            }
                            onChange={(date, dateString) => {
                              setFieldValue("passport_expire_date", dateString);
                            }}
                          />
                          {errors.passport_expire_date &&
                            touched.passport_expire_date && (
                              <div className="text-danger">
                                {errors.passport_expire_date}
                              </div>
                            )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <Input
                            label={"Tax Identification Number"}
                            value={values.tin}
                            onChange={(e) => {
                              setFieldValue("tin", e.target.value);
                            }}
                          />
                          {errors.tin && touched.tin && (
                            <div className="text-danger">{errors.tin}</div>
                          )}
                        </div>
                        <div className="col-md-6 mb-4">
                          {/* <Input
                          label={"Primary Phone"}
                          isRequired
                          value={values.contact_number}
                          onChange={(e) => {
                            setFieldValue("contact_number", e.target.value);
                          }}
                        /> */}
                          <label className="required">Contact Number</label>
                          <PhoneInput
                            // className="form-control"
                            defaultCountry="BD"
                            value={values.contact_number}
                            placeholder="Enter contact number"
                            flags={flags}
                            onChange={(value) => {
                              setFieldValue("contact_number", value);
                            }}
                          />
                          {errors.contact_number && (
                            <div className="text-danger">
                              {errors.contact_number}
                            </div>
                          )}
                        </div>

                        <div className="col-md-6 mb-4">
                          {/* <Input
                          label={"Alt Contact No."}
                          value={values.alternative_contact_number}
                          onChange={(e) => {
                            setFieldValue(
                              "alternative_contact_number",
                              e.target.value
                            );
                          }}
                        /> */}
                          <label>Alt Contact No.</label>
                          <PhoneInput
                            // className="form-control"
                            defaultCountry="BD"
                            value={values.alternative_contact_number}
                            placeholder="Enter alternate contact number"
                            flags={flags}
                            onChange={(value) => {
                              setFieldValue(
                                "alternative_contact_number",
                                value
                              );
                            }}
                          />
                          {errors.alternative_contact_number &&
                            touched.alternative_contact_number && (
                              <div className="text-danger">
                                {errors.alternative_contact_number}
                              </div>
                            )}
                        </div>

                        <div className="col-md-6 mb-4">
                          <Input
                            label={"Email"}
                            isRequired
                            value={values.email}
                            onChange={(e) => {
                              setFieldValue("email", e.target.value);
                            }}
                          />
                          {errors.email && touched.email && (
                            <div className="text-danger">{errors.email}</div>
                          )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <Input
                            label={"Alternative Email"}
                            value={values.alternative_email}
                            onChange={(e) => {
                              setFieldValue(
                                "alternative_email",
                                e.target.value
                              );
                            }}
                          />
                          {errors.alternative_email &&
                            touched.alternative_email && (
                              <div className="text-danger">
                                {errors.alternative_email}
                              </div>
                            )}
                        </div>
                        <div className="col-md-3 mb-4">
                          <SelectInput
                            label={"Blood Group"}
                            isRequired
                            options={bloodGroupOptions}
                            value={values.blood_group}
                            onChange={(value) => {
                              setFieldValue("blood_group", value);
                            }}
                          />
                          {errors.blood_group && touched.blood_group && (
                            <div className="text-danger">
                              {errors.blood_group}
                            </div>
                          )}
                        </div>
                        <div className="col-md-3 mb-4">
                          <SelectInput
                            label={"Disability"}
                            isRequired
                            options={disabilityOptions}
                            value={values.is_disable}
                            onChange={(value) => {
                              setFieldValue("is_disable", value);
                            }}
                          />
                          {errors.is_disable && touched.is_disable && (
                            <div className="text-danger">
                              {errors.is_disable}
                            </div>
                          )}
                        </div>
                        {values.is_disable == 1 && (
                          <div className="col-md-6 mb-4">
                            <Input
                              label={"Type of disability"}
                              value={values.about_disability}
                              onChange={(e) => {
                                setFieldValue(
                                  "about_disability",
                                  e.target.value
                                );
                              }}
                            />
                            {errors.about_disability &&
                              touched.about_disability && (
                                <div className="text-danger">
                                  {errors.about_disability}
                                </div>
                              )}
                          </div>
                        )}
                        <div className="col-md-6 mb-4">
                          {/* <Input
                          label={"Emergency Contact No"}
                          value={values.emergency_contact_number}
                          onChange={(e) => {
                            setFieldValue(
                              "emergency_contact_number",
                              e.target.value
                            );
                          }}
                        /> */}
                          <label>Emergency Contact No</label>
                          <PhoneInput
                            // className="form-control"
                            defaultCountry="BD"
                            value={values.emergency_contact_number}
                            placeholder="Enter emergency contact number"
                            flags={flags}
                            onChange={(value) => {
                              setFieldValue("emergency_contact_number", value);
                            }}
                          />
                          {errors.emergency_contact_number &&
                            touched.emergency_contact_number && (
                              <div className="text-danger">
                                {errors.emergency_contact_number}
                              </div>
                            )}
                        </div>
                        <div className="col-md-6 mb-4">
                          <Input
                            label={"Relation with the Contact"}
                            value={values.relationsip_with_emergency_contact}
                            onChange={(e) => {
                              setFieldValue(
                                "relationsip_with_emergency_contact",
                                e.target.value
                              );
                            }}
                          />
                          {errors.relationsip_with_emergency_contact &&
                            touched.relationsip_with_emergency_contact && (
                              <div className="text-danger">
                                {errors.relationsip_with_emergency_contact}
                              </div>
                            )}
                        </div>

                        <div className="col-md-6 mb-4">
                          <label className="">Passport Issue Date</label>
                          <DatePicker
                            style={{ width: "100%", height: "44px" }}
                            format="YYYY-MM-DD"
                            value={
                              values.passport_issue_date
                                ? moment(values.passport_issue_date)
                                : null
                            }
                            onChange={(date, dateString) => {
                              setFieldValue("passport_issue_date", dateString);
                            }}
                          />
                          {errors.passport_issue_date &&
                            touched.passport_issue_date && (
                              <div className="text-danger">
                                {errors.passport_issue_date}
                              </div>
                            )}
                        </div>

                        <div className="col-md-6 mb-4">
                          <label className="">Passport Expiry Date</label>
                          <DatePicker
                            style={{ width: "100%", height: "44px" }}
                            format="YYYY-MM-DD"
                            value={
                              values.passport_expiry_date
                                ? moment(values.passport_expiry_date)
                                : null
                            }
                            onChange={(date, dateString) => {
                              setFieldValue("passport_expiry_date", dateString);
                            }}
                          />
                          {errors.passport_expiry_date &&
                            touched.passport_expiry_date && (
                              <div className="text-danger">
                                {errors.passport_expiry_date}
                              </div>
                            )}
                        </div>

                        <div className="col-md-6 mb-4">
                          <label className="">
                            Work Permit Issue Date (if Foreigner)
                          </label>
                          <DatePicker
                            style={{ width: "100%", height: "44px" }}
                            format="YYYY-MM-DD"
                            value={
                              values.work_permit_issue_date
                                ? moment(values.work_permit_issue_date)
                                : null
                            }
                            onChange={(date, dateString) => {
                              setFieldValue(
                                "work_permit_issue_date",
                                dateString
                              );
                            }}
                          />
                          {errors.work_permit_issue_date &&
                            touched.work_permit_issue_date && (
                              <div className="text-danger">
                                {errors.work_permit_issue_date}
                              </div>
                            )}
                        </div>

                        <div className="col-md-6 mb-4">
                          <label className="">
                            Work Permit Expiry Date (if Foreigner)
                          </label>
                          <DatePicker
                            style={{ width: "100%", height: "44px" }}
                            format="YYYY-MM-DD"
                            value={
                              values.work_permit_expiry_date
                                ? moment(values.work_permit_expiry_date)
                                : null
                            }
                            onChange={(date, dateString) => {
                              setFieldValue(
                                "work_permit_expiry_date",
                                dateString
                              );
                            }}
                          />
                          {errors.work_permit_expiry_date &&
                            touched.work_permit_expiry_date && (
                              <div className="text-danger">
                                {errors.work_permit_expiry_date}
                              </div>
                            )}
                        </div>

                        <div className="col-md-6 mb-4">
                          <label className="">
                            Visa Expiry Date (if Foreigner)
                          </label>
                          <DatePicker
                            style={{ width: "100%", height: "44px" }}
                            format="YYYY-MM-DD"
                            value={
                              values.visa_expiry_date
                                ? moment(values.visa_expiry_date)
                                : null
                            }
                            onChange={(date, dateString) => {
                              setFieldValue("visa_expiry_date", dateString);
                            }}
                          />
                          {errors.visa_expiry_date &&
                            touched.visa_expiry_date && (
                              <div className="text-danger">
                                {errors.visa_expiry_date}
                              </div>
                            )}
                        </div>

                        <div className="col-md-6 mb-4">
                          <label>Referral Information</label>
                          <textarea
                            label={"Referral"}
                            className="form-control"
                            value={values.referral}
                            onChange={(e) => {
                              setFieldValue("referral", e.target.value);
                            }}
                          />
                          {errors.referral && touched.referral && (
                            <div className="text-danger">{errors.referral}</div>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 mb-4">
                          <SelectInput
                            label={"Are you an Ex BRACU Employee?"}
                            isRequired
                            options={[
                              {
                                label: "Yes",
                                value: "Yes",
                              },
                              {
                                label: "No",
                                value: "No",
                              },
                            ]}
                            value={values.is_ex_employee}
                            onChange={(value) => {
                              setFieldValue("is_ex_employee", value);
                            }}
                          />
                          {errors.is_ex_employee && touched.is_ex_employee && (
                            <div className="text-danger">
                              {errors.is_ex_employee}
                            </div>
                          )}
                        </div>
                        {values.is_ex_employee == "Yes" && (
                          <Fragment>
                            <div className="col-md-6 mb-4">
                              <Input
                                label={"BRACU PIN"}
                                isRequired
                                value={values.ex_employee_code}
                                onChange={(e) => {
                                  setFieldValue(
                                    "ex_employee_code",
                                    e.target.value
                                  );
                                }}
                              />
                              {errors.ex_employee_code && (
                                <div className="text-danger">
                                  {errors.ex_employee_code}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-4">
                              <label>Joining Date</label>

                              <DatePicker
                                style={{ width: "100%", height: "44px" }}
                                format="YYYY-MM-DD"
                                value={
                                  values.prev_joining_date
                                    ? moment(values.prev_joining_date)
                                    : null
                                }
                                onChange={(date, dateString) => {
                                  setFieldValue(
                                    "prev_joining_date",
                                    dateString
                                  );
                                }}
                              />
                              {errors.prev_joining_date && (
                                <div className="text-danger">
                                  {errors.prev_joining_date}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-4">
                              <label>Last Working Day</label>
                              <DatePicker
                                style={{ width: "100%", height: "44px" }}
                                format="YYYY-MM-DD"
                                value={
                                  values.prev_last_working_date
                                    ? moment(values.prev_last_working_date)
                                    : null
                                }
                                onChange={(date, dateString) => {
                                  setFieldValue(
                                    "prev_last_working_date",
                                    dateString
                                  );
                                }}
                              />
                              {errors.prev_last_working_date && (
                                <div className="text-danger">
                                  {errors.prev_last_working_date}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 mb-4">
                              <Input
                                label={"Supervisor Name"}
                                value={values.ex_superviosor_name}
                                onChange={(e) => {
                                  setFieldValue(
                                    "ex_superviosor_name",
                                    e.target.value
                                  );
                                }}
                              />
                              {errors.ex_superviosor_name &&
                                touched.ex_superviosor_name && (
                                  <div className="text-danger">
                                    {errors.ex_superviosor_name}
                                  </div>
                                )}
                            </div>
                            <div className="col-md-6 mb-4">
                              <Input
                                label={"Supervisor Designation"}
                                value={values.ex_superviosor_designation}
                                onChange={(e) => {
                                  setFieldValue(
                                    "ex_superviosor_designation",
                                    e.target.value
                                  );
                                }}
                              />
                              {errors.ex_superviosor_designation &&
                                touched.ex_superviosor_designation && (
                                  <div className="text-danger">
                                    {errors.ex_superviosor_designation}
                                  </div>
                                )}
                            </div>
                            <div className="col-md-6 mb-4">
                              <Input
                                label={"Supervisor Email"}
                                value={values.ex_superviosor_email}
                                onChange={(e) => {
                                  setFieldValue(
                                    "ex_superviosor_email",
                                    e.target.value
                                  );
                                }}
                              />
                              {errors.ex_superviosor_email &&
                                touched.ex_superviosor_email && (
                                  <div className="text-danger">
                                    {errors.ex_superviosor_email}
                                  </div>
                                )}
                            </div>
                            <div className="col-md-6 mb-4">
                              <Input
                                label={"Supervisor Phone"}
                                value={values.ex_superviosor_phone}
                                onChange={(e) => {
                                  setFieldValue(
                                    "ex_superviosor_phone",
                                    e.target.value
                                  );
                                }}
                              />
                              {errors.ex_superviosor_phone &&
                                touched.ex_superviosor_phone && (
                                  <div className="text-danger">
                                    {errors.ex_superviosor_phone}
                                  </div>
                                )}
                            </div>
                          </Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="edit_btn_group modal-footer p-0 m-0">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Attachments NID</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            className="w-100"
            src={
              process.env.REACT_APP_API_URL?.replace("/api/v1", "") +
              "/recruitment-uploads/" +
              profile.nid_file_location
            }
            alt="img"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
